


























































import forEach from 'lodash/forEach';
import moment from 'moment';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BaseComponent from './Base';

const officeScheduleStore = namespace('officeSchedule');

@Component
export default class WorkingHours extends BaseComponent {
    @Prop({type: String, required: true}) protected shortTel: string;
    @Prop({type: String, required: true}) protected fullTel: string;
    @Prop({type: String, required: false}) protected email: string;
    @Prop({type: Boolean, required: true}) protected smallFont: boolean;
    @Prop({type: String}) protected brandColor: string;
    @Prop({type: String, default: ''}) protected additionalInfo: string;

    protected isVisible: boolean = false;
    protected current: string = '';

    @officeScheduleStore.Getter('isOpenNow') protected readonly isOpenNow: boolean;
    @officeScheduleStore.State('days') protected readonly days: any;

    protected get status(): string {
        return this.t(this.isOpenNow ? 'Open' : 'Closed');
    }

    protected get contact(): string {
        return this.t('Contact');
    }

    protected get workingHoursHover(): string {
        return this.t('Working hours');
    }

    protected get telLabel(): string {
        /*return `${this.t('Tel:')} ${this.shortTel}`;*/
        return `${this.t(this.shortTel)}`;
    }

    protected get emailLabel(): string {
        return `${this.t('Email:')} ${this.email}`;
    }

    protected get currentDayIndex(): number {
        return moment().day();
    }

    protected get currentDayWork(): string {
        if (this.current === '') {
            return this.t('Closed today');
        }
        return this.t('Open today') + ' ' + this.current;
    }

    protected get daysFormatted(): any {
        const formatted: any = [];
        forEach(this.days, (day, key) => {
            if (day === null) {
                return;
            }
            const start = moment().startOf('day').add(day.start, 'seconds');
            const end = moment().startOf('day').add(day.end, 'seconds');
            const format = (start.minutes() !== 0 || end.minutes() !== 0) ? 'HH:mm' : 'HH';
            const index = this.getDayIndex(key);

            if (index === this.currentDayIndex) {
                if (day.active) {
                    this.current = start.format(format) + ' - ' + end.format(format);
                }
            }

            formatted.push({
                active: day.active,
                today: index === this.currentDayIndex,
                name: this.t(moment().day(index).format('dddd')),
                from: start.format(format),
                to: end.format(format),
            });
        });

        return formatted;
    }

    protected onClick(): void {
        this.isVisible = !this.isVisible;
    }

    protected onFocus(e): void {
        if (this.onWorkinHours(e)) {
            this.$nextTick(() => this.isVisible = true);
        }
    }

    protected onBlur(): void {
        this.$nextTick(() => this.isVisible = false);
    }

    /**
     * @param {string} dayShortName
     * @returns {number}
     */
    protected getDayIndex(dayShortName: string | number): number {
        switch (dayShortName) {
            case 'mon':
                return 1;
            case 'tue':
                return 2;
            case 'wed':
                return 3;
            case 'thu':
                return 4;
            case 'fri':
                return 5;
            case 'sat':
                return 6;
            case 'sun':
                return 0;
            default:
                return 1;
        }
    }

    private onWorkinHours(e) {
        return (e.target.id !== 'phone' && e.target.id !== 'open-data' && e.target.id !== 'wrapper') ? true : false;
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/WorkingHours.vue